import React from 'react';

import { Box } from '@chakra-ui/react';
import DotsMoreComponent from 'components/Comment/CommentMore';
import ModularCommentDisplay from 'components/Comment/ModularCommentDisplay';
import { useSelector } from 'react-redux';
import { selectLoggedInEmployeeId } from 'selectors/loggedInEmployee';
import styled from 'styled-components';

import { ThreeDots } from 'assets/assetsV1/iconComponents';

import { PraiseSvgIconColored } from 'constants/icons';

import { Avatar } from 'uiToolkitV1/Avatar';

const StyledModularCommentDisplay = styled(ModularCommentDisplay)`
  display: flex;
  justify-content: ${(props) => (props.isLoggedInEmployee ? 'flex-end' : 'flex-start')};
`;

export default function ManualComment({ commentMoreMenuItems, isDisabled = false, isKudos = false, ...props }) {
  const { fromEmployee } = props;
  const fromEmployeeId = fromEmployee?.id || null;
  const loggedInEmployeeId = useSelector(selectLoggedInEmployeeId);
  const isLoggedInEmployee = fromEmployeeId === loggedInEmployeeId;
  return (
    <StyledModularCommentDisplay isLoggedInEmployee={isLoggedInEmployee} {...props}>
      <Box
        display="flex"
        padding="8px"
        alignItems="flex-start"
        gap="4px"
        alignSelf="stretch"
        borderRadius="4px"
        background={isLoggedInEmployee ? '#F2F2F2' : '#F5F7F9'}
        flex={1}
      >
        <Box display="flex" alignItems="flex-start" padding="4px">
          <Avatar src={fromEmployee?.getProfileImage()} size={32} name="" />
        </Box>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="flex-start"
          flex="1 0 0"
          border={isKudos ? '1px solid #77C16C' : ''}
        >
          <Box
            display="flex"
            padding="2px 0px"
            alignItems="center"
            flex="1 0 0"
            alignSelf="stretch"
            justifyContent="space-between"
          >
            <Box display="flex" padding="2px" alignItems="center">
              <ModularCommentDisplay.HistoryFromName isColon={false} />
              {isKudos ? (
                <PraiseSvgIconColored
                  // @ts-expect-error:  params type error
                  containerSize="fixed16px"
                  size="fixed16px"
                  leftGutter={1}
                />
              ) : null}
            </Box>
            <Box display="flex" paddingRight="4px" alignItems="center" gap="8px" alignSelf="stretch">
              <Box display="flex" padding="4px" alignItems="center">
                <ModularCommentDisplay.CreatedAtHistory />
              </Box>
              <Box>
                <Box display="flex" padding="4px" alignItems="center">
                  <DotsMoreComponent
                    isDisabled={isDisabled}
                    menuItems={commentMoreMenuItems}
                    iconComponent={<ThreeDots sx={{ transform: 'rotate(90deg)' }} boxSize="24px" />}
                    className=""
                  />
                </Box>
              </Box>
            </Box>
          </Box>
          <Box display="flex" padding="4px" alignItems="center">
            <ModularCommentDisplay.HistoryMessage />
          </Box>
        </Box>
      </Box>
    </StyledModularCommentDisplay>
  );
}
